import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss']
})
export class MultiSelectDropdownComponent {
  @Input() items: string[] = []; // All available dates
  @Input() control!: FormControl; // Holds selected values
  @Input() placeholder: string = 'Select dates'; // Placeholder text
  @Output() selectionChange = new EventEmitter<string[]>(); // Emit selection changes
  dropdownOpen = false;
  

  ngOnInit() {
    // Ensure FormControl starts empty (no dates pre-selected)
    if (!this.control.value || !Array.isArray(this.control.value)) {
      this.control.setValue([]); // Start with an empty selection
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  closeDropdown() {
    this.dropdownOpen = false;
  }

  onCheckboxChange(value: string, event: any) {
    let selectedValues = this.control.value ? [...this.control.value] : [];
  
    if (event.target.checked) {
      if (!selectedValues.includes(value)) {
        selectedValues.push(value);
      }
    } else {
      selectedValues = selectedValues.filter(item => item !== value);
    }
  
    this.control.setValue(selectedValues, { emitEvent: true }); 
    this.selectionChange.emit(selectedValues);
  }
  
  
  

  isChecked(value: string): boolean {
    return this.control.value?.includes(value);
  }
  
  

  getSelectedText(): string {
    return this.control.value && this.control.value.length 
      ? this.control.value.join(', ') 
      : this.placeholder;
  }
  
}
